import { Badge, SystemIcon } from "@justworkshr/milo-components";
import { Alert } from "@justworkshr/milo-core";

import { SingleCensusType, SingleDependentType } from "types";
import { HealthCensusType } from "./types";
import PrefilledCensus from "./PrefilledCensus";
import styles from "./Prefilled.module.css";

type PrefilledProps = {
  onUpdateClick: (censusData: SingleCensusType) => void;
  updateDependent?: (
    dependentData: SingleDependentType | null,
    employeeData: SingleCensusType,
    isDelete?: boolean
  ) => void;
  censuses: {
    complete: boolean;
    censusData: HealthCensusType | SingleCensusType;
  }[];
  hasError?: boolean;
  flowName?: string;
};

const Prefilled = ({
  censuses,
  onUpdateClick,
  updateDependent,
  hasError,
  flowName = "wc",
}: PrefilledProps) => {
  const completeCount = censuses.filter((emp) => {
    if (flowName === "wc") return emp.complete;
    return (
      // @ts-ignore
      emp.censusData.dependentCensuses?.every((dep) => dep.complete) &&
      emp.complete
    );
  }).length;

  let totalCount = censuses.length;
  for (const emp of censuses) {
    if (flowName !== "wc") {
      // @ts-ignore
      totalCount += emp.censusData.dependentCensuses?.length || 0;
    }
  }

  return (
    <div>
      {completeCount === censuses.length && !hasError && flowName === "wc" && (
        <Alert color="additive" className={styles.prefilledAlert}>
          <div className={styles.alertContent}>
            <SystemIcon iconName="check-circle" />
            <p>Nice work, you got 'em all.</p>
          </div>
        </Alert>
      )}

      {hasError && (
        <Alert color="destructive" className={styles.prefilledAlert}>
          <div className={styles.alertContent}>
            <SystemIcon iconName="error" />
            <p>
              Make sure you update all teammates. We’ve saved your work if you
              need to finish up later on.
            </p>
          </div>
        </Alert>
      )}

      {censuses.length > 0 && (
        <>
          <h4>
            {flowName === "wc" ? "Team members " : "Employees and dependents "}{" "}
            <Badge>{totalCount}</Badge>
          </h4>
          <ul className={styles.prefilledEmployeesList}>
            {censuses.map((emp) => (
              <PrefilledCensus
                flowName={flowName}
                key={emp.censusData.uuid}
                census={emp}
                onClick={onUpdateClick}
                updateDependent={updateDependent}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default Prefilled;
